import { ref } from "vue";
import {
    Resource,
    ResourceState,
    resourceStatePrototype,
    useResourceState,
} from "@/domains/app/resource";

export type WeaponType = Resource & {
    label: string;
};

export type WeaponTypeState = ResourceState<WeaponType>;

/**
 * Create a weaponType state to get data and its mutators
 * @param id Id of the weaponType that the state should be related to
 * @returns a weaponType state with the data and mutators
 */
export function useWeaponType(id?: number): WeaponTypeState {
    const state: WeaponTypeState = {
        data: ref(null),
        apiRoute: "weapon-types",
        apiErrors: ref(null),
        save: () => resourceStatePrototype.save(state),
        del: () => resourceStatePrototype.del(state),
        init: () =>
            resourceStatePrototype.init(id, state, {
                id: -1,
                label: "",
            }),
    };

    return useResourceState(state);
}
